import lookupTables from "../data/lookup_tables.json";

export type optionWithId = {
  id: number;
  lineageText: string;
  description: string;
  translate: string;
};

export function getLookupOptions(arrayType: string): optionWithId[] {
  switch (arrayType) {
    case "accessibility": {
      return lookupTables.accessibilitySupports
        .filter(
          (item) => item.lineageText !== "Other" && item.lineageText !== "Unknown"
        )
        .map((item) => ({
          id: item.id,
          lineageText: item.lineageText,
          description: item.description,
          translate: item.translate
        }));
    }
    case "serviceCategory": {
      return lookupTables.serviceCategories
        .filter((item) => {return item.id !== 1500105;})
        .map((item) => ({
          id: item.id,
          lineageText: item.text,
          description: item.description,
          translate: item.translate
        }));
    }
    case "servicesProvided": {
      return lookupTables.servicesProvided
        .map((item) => ({
          id: item.id,
          lineageText: item.description,
          description: item.category,
          translate: item.text
        }));
    }
   case "age": {
      return lookupTables.patientAgeGroups
        .filter((item) => item.lineageText !== "Unknown")
        .map((item) => ({
          id: item.id,
          lineageText: item.lineageText,
          description: item.description,
          translate: item.translate
        }));
    }
    case "community": {
      return lookupTables.patientCommunities
        .filter(
          (item) => item.lineageText !== "Other" && item.lineageText !== "Unknown"
        )
        .map((item) => ({
          id: item.id,
          lineageText: item.lineageText,
          description: item.description,
          translate: item.translate
        }));
    }
    case "languages": {
      return lookupTables.languages
        .filter(
          (item) =>
            item.lineageText !== "Other" && item.lineageText !== "Unknown"
        )
        .map((item) => ({
          id: item.id,
          lineageText: item.lineageText,
          description: item.description,
          translate: item.translate
        }));
    }
    case "payment": {
      return lookupTables.paymentTypes
        .filter(
          (item) =>
            item.lineageText !== "Other" && item.lineageText !== "Unknown"
        )
        .map((item) => ({
          id: item.id,
          lineageText: item.lineageText,
          description: item.description,
          translate: item.translate
        }));
    }
    case "telehealth": {
      return lookupTables.telehealthOptions
        .map((item) => ({
          id: item.id,
          lineageText: item.lineageText, 
          description: item.description,
          translate: item.translate
        }));
    }
    default: {
      return [];
    }
  }
}
